interface KoalaProps {
  className?: string;
}

export const Koala = ({ className }: KoalaProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M21 7a4.999 4.999 0 0 0 -3.026 -4.607a5 5 0 0 0 -5.97 1.607h-.008a5 5 0 1 0 -8.996 3l.008 .008a5 5 0 0 0 2.992 8.992h.008a5 5 0 0 0 3.992 2a5 5 0 0 0 3.992 -2h.016a5 5 0 0 0 2.992 -8.992l.008 -.008a4.985 4.985 0 0 0 1.992 -3" />
      <path d="M9 12c.5 1 1.5 2 3 2s2.5 -1 3 -2" />
      <path d="M9 10h.01" />
      <path d="M15 10h.01" />
    </svg>
  );
};
